import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import parse from 'html-react-parser';
import DOMPurify from 'dompurify';
import './style.scss'
import { getOneBlog } from '../../services/blog';
import { Box, CircularProgress, Container, Typography } from '@mui/material';

export const SingleBlog = () => {
  const { id } = useParams()

    const [blog, setBlog] = useState({})
    const [loading, setLoading] = useState(false)

  const getBlog = async () => {
    try {
      const response = await getOneBlog(id)
      setBlog(response.data[0])
      console.log("blog", response.data)
    } catch (error) {
      console.log("error", error)
    } finally {
      setLoading(false)
    }
  }
  useEffect(() => {
    setLoading(true);
    window.scrollTo({ top: 0, behavior: "smooth" });
    getBlog()
  }, [])

  return (
    <Box className="blog-content" py={5}>
        <Container>
        {
            loading ? (
                <div className="loading-container">
                    <CircularProgress />
                </div>
            ) : (
                <>
                    <h1 className="blog-title">{blog?.title?.rendered}</h1>
                    <p className="blog-published-date">
                        Published {new Date(blog?.date).toLocaleString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
                    </p>
                    <div className="blog-content-text">
                        {parse(DOMPurify.sanitize(blog?.content?.rendered))}
                    </div>
                </>
            )}

            {
                !loading && !blog && (
                    <div className="no-blogs-container">
                        <Typography variant="h6">No blogs found</Typography>
                    </div>
                )
            }
            </Container>
    </Box>
  )
}
